const integer = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 })
const decimal = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 1 })

export function formatTonnes(value) {
  return `${integer.format(Math.round(value))} t CO₂e`
}

export function formatNumber(value) {
  return integer.format(Math.round(value))
}

export function formatPercent(value, digits = 0) {
  return `${new Intl.NumberFormat("de-DE", { maximumFractionDigits: digits, minimumFractionDigits: digits }).format(value * 100)} %`
}

export function formatDecimal(value) {
  return decimal.format(value)
}
